export interface IUiState {
  isOrderModalActive: boolean;
  isAnyModalOn: boolean;
}

export enum UiTypes {
  TOGGLE_ORDER_MODAL = 'TOGGLE_ORDER_MODAL',
  TOGGLE_IS_ANY_MODAL_ACTIVE = 'TOGGLE_IS_ANY_MODAL_ACTIVE',
}
